import { Alert, Box, Typography } from "@mui/material"
import { GroupType } from "authoring/lib/enum/group-type.mjs"
import { DialogBox } from "lib/@components/dialogBox"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function ApplyGroupDialog({ groupName = "", scheduleCount = 0, groupType = "", isReapply = false }) {
    const scheduleLabel = scheduleCount === 1 ? "schedule" : "schedules"

    return (
        <DialogBox
            title={
                <Box display={"flex"} alignItems={"center"} gap={"20px"} data-cy="apply-group-dialog-title">
                    <Iconify icon={"mdi:tick-circle-outline"} />
                    <Typography variant="h5">Apply Group to Schedules</Typography>
                </Box>
            }
            value={true}
            data-cy="apply-group-dialog"
            okCaption="Apply"
        >
            <Typography mt={2}>
                This will apply{" "}
                <Typography component={"span"} fontWeight={600}>
                    '{groupName}'
                </Typography>{" "}
                to{" "}
                <Typography component={"span"} fontWeight={600}>
                    {scheduleCount} {scheduleLabel}
                </Typography>
                .
            </Typography>
            <Alert
                severity="info"
                sx={{
                    mt: 2,
                    alignItems: "center",
                    "& .MuiAlert-icon": { display: "flex", alignItems: "center" },
                }}
                data-cy="apply-group-dialog-alert"
            >
                {getApplyGroupAlertMessage(groupType)}
            </Alert>
            <If value={isReapply}>
                <Alert
                    severity="warning"
                    sx={{
                        mt: 2,
                        alignItems: "center",
                        "& .MuiAlert-icon": { display: "flex", alignItems: "center" },
                    }}
                    data-cy="apply-group-dialog-removed-schedules-alert"
                >
                    Any schedule removed from this group after unlocking will keep its previously applied changes, they
                    will not be undone.
                </Alert>
            </If>
        </DialogBox>
    )
}

function getApplyGroupAlertMessage(groupType = "") {
    if (groupType === GroupType.OVERWRITE) {
        return "When applied, selected tasks in each affected schedule are updated in place."
    }
    if (groupType === GroupType.INTRODUCTION) {
        return "When applied, the introduction and notes will overwrite existing introductions on each selected schedule."
    }
    if (groupType === GroupType.LEADING_SUMMARY) {
        return "When applied, the leading summary and any legislation references are written to each selected schedule. Existing leading summaries will be overwritten or skipped based on your configuration."
    }
    if (groupType === GroupType.ADD) {
        return "When applied, tasks are added to the bottom of each schedule in the order you created them. On a re-apply, previously added tasks are updated in place and any removed from this list are taken off the schedules."
    }

    return "When applied, tasks are added to the bottom of each schedule in the order you created them."
}
